<template>
    <div class="login-new-box">
        <div class="logo">
            <van-image height=".99rem" fit="contain" src="/static/newImg/static/logo.png"/>
        </div>
        <div class="l">
            <van-image height="4.5rem" fit="contain" src="/static/newImg/static/logo/2060796602330750978.avif"/>
        </div>
        <div class="tab">
            <van-tabs v-model="typeActive" background="#0a0a0a" color="#DFB372" title-active-color="#DFB372" title-inactive-color="#fff">
                <van-tab title="注册"></van-tab>
                <van-tab title="登录"></van-tab>
            </van-tabs>
        </div>
        <div class="login-content">
            <div class="check" v-if="typeActive == 0">
                <van-tabs v-model="typeLogin" type="card" background="#1a1a1a" color="#292A2c" title-active-color="#DFB372" title-inactive-color="#bebebe">
                    <van-tab title="会员账号"></van-tab>
                    <van-tab title="手机号码"></van-tab>
                </van-tabs>
            </div>
            <van-form @submit="onSubmit" v-if="typeActive == 1">
                <van-field
                    v-model="loginInfo.name"
                    :border="false"
                    name="name"
                    label="*"
                    placeholder="请输入用户名或手机号"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_name.png" class="field-icon" />
                    </template>
                </van-field>
                <van-field
                    v-model="loginInfo.password"
                    type="password"
                    :border="false"
                    name="password"
                    label="*"
                    placeholder="请输入密码"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_pwd.png" class="field-icon" />
                    </template>
                </van-field>
                <!-- <div class="flex-c-b">
                    <van-field
                    v-model="loginInfo.code"
                    :border="false"
                    name="code"
                    label="*"
                    placeholder="请输入验证码"
                    :rules="[{ required: true }]"/>
                    <img style="cursor: pointer; height: 30px;margin-left: 10px;margin-bottom: 15px;" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                </div> -->
                <div class="gou">
                    <van-checkbox v-model="checkedLoginUser" shape="square" checked-color="#3CC82F" icon-size="15px">记住账号密码</van-checkbox>
                </div>
                <div class="btn">
                    <van-button type="info" block  native-type="submit" class="login-btn">登录</van-button>
                    <div class="other flex-c-b"> 
                        <div>联系客服</div>
                        <div @click="handleClose">免费试玩</div>
                        <div>忘记密码</div>
                    </div>
                </div>
            </van-form>

            <van-form @submit="onSubmit" v-if="typeActive == 0">
                <van-field
                    v-model="registerInfo.name"
                    :border="false"
                    name="name"
                    label="*"
                    placeholder="请输入用户名(字母或数字组合6-16位)"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_name.png" class="field-icon" />
                    </template>
                </van-field>
                <van-field
                    v-if="typeLogin == 1"
                    v-model="registerInfo.phone"
                    type="tel"
                    :border="false"
                    name="phone"
                    label="*"
                    placeholder="请输入手机号"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_phone.png" class="field-icon" />
                    </template>
                </van-field>
                <van-field
                    v-if="typeLogin == 1"
                    v-model="registerInfo.smscode"
                    :border="false"
                    name="smscode"
                    label="*"
                    placeholder="请输入短信验证码"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_code.png" class="field-icon" />
                    </template>
                    <template #button>
                        <span class="sms-btn" @click="sendSmsCode" v-if="smsCountdown == 0">获取验证码</span>
                        <span class="sms-btn sms-btn-disabled" v-else>{{ smsCountdown }}s</span>
                    </template>
                </van-field>
                <van-field
                    v-if="typeLogin == 0"
                    v-model="registerInfo.password"
                    type="password"
                    :border="false"
                    name="password"
                    label="*"
                    placeholder="请输入密码"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_pwd.png" class="field-icon" />
                    </template>
                </van-field>
                <van-field
                    v-if="typeLogin == 0"
                    v-model="registerInfo.confirmPass"
                    type="password"
                    :border="false"
                    name="password"
                    label="*"
                    placeholder="确认密码"
                    :rules="[{ required: true }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_pwd.png" class="field-icon" />
                    </template>
                </van-field>
                <van-field
                    v-model="registerInfo.pid"
                    :border="false"
                    name="pid"
                    label="*"
                    placeholder="请输入您的邀请码"
                    :rules="[{ required: false }]">
                    <template #left-icon>
                        <img src="/static/newImg/icon_shakehand.png" class="field-icon" />
                    </template>
                </van-field>

                <!-- <div class="flex-c-b">
                    <van-field
                    v-model="registerInfo.code"
                    :border="false"
                    name="code"
                    label="*"
                    placeholder="请输入验证码"
                    :rules="[{ required: true }]"/>
                    <img style="cursor: pointer; height: 30px;margin-left: 10px;margin-bottom: 15px;" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                </div> -->
                <div class="btn">
                    <van-button type="info" block native-type="submit" class="login-btn">注册</van-button>
                </div>
            </van-form>
            
        </div>
    </div>
</template>
<script>
export default {
  name: "loginNew",
  props: {
    defaultType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
        typeActive: 1,
        typeLogin: 0,
        loginInfo: {},
        registerInfo: {},
        checkedLoginUser: true,

        imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
        index: 0,
        smsCountdown: 0,
        smsTimer: null,
    };
  },
  mounted() {
    this.typeActive = this.defaultType;
    this.changIndex();
    if (sessionStorage.getItem('pid')) {
      this.$set(this.registerInfo, 'pid', sessionStorage.getItem('pid'));
    }
  },
  watch: {
    typeActive() {
      this.changIndex();
    }
  },
  methods: {
    onClickTabs(name, title) {
        console.log(name, title);
        this.typeActive = name
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    handleClose() {
        this.$emit("close");
    },
    onSubmit(values) {
    //   console.log('submit', values);
    //   console.log(this.typeLogin, '0会员账号  1手机账号')
    //   console.log(this.typeActive, '0注册  1登录')
      if(this.typeActive == 0) {
          console.log('注册')
          this.register()
        }else if(this.typeActive == 1) {
            console.log('登录')
          this.login()
      }
    },

    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name) {
        that.$toast('请输入账号');
        return;
      }
      if (!info.password) {
        that.$toast('请输入密码');
        return;
      }

      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$toast('请输入验证码');
      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$toast('验证码错误');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }

    //   that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$toast(res.message);
        //   that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          localStorage.setItem('token', res.data.api_token); // 持久化，关闭浏览器重开保持登录
          that.$store.commit('changToken');
          // 登录成功后立即刷新用户信息（昵称、余额等）
          that.$apiFun.post('/api/user', {}).then(infoRes => {
            if (infoRes.code === 200) {
              let userInfo = infoRes.data;
              let str = userInfo.current_vip || '';
              let index = str.indexOf('P');
              userInfo.vip = index >= 0 ? str.substr(index + 1) : '';
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              that.$store.commit('changUserInfo');
            }
          });
          that.$emit("close");
        //   that.$parent.getUserInfo();
        //   that.$parent.openDaoTime();

        //   that.$parent.goNav('/');
        }
        // that.$parent.hideLoading();
      });
    },
    sendSmsCode() {
      let that = this;
      let phone = that.registerInfo.phone;
      if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
        that.$toast('请输入正确的手机号');
        return;
      }
      that.$apiFun.post('/api/sendSmsCode', { phone: phone }).then(res => {
        if (res.code == 200) {
          that.$toast('验证码已发送');
          that.smsCountdown = 60;
          that.smsTimer = setInterval(() => {
            that.smsCountdown--;
            if (that.smsCountdown <= 0) {
              clearInterval(that.smsTimer);
              that.smsCountdown = 0;
            }
          }, 1000);
        } else {
          that.$toast(res.message);
        }
      });
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.$toast('用户名长度6~16位，以字母或数字组合');
        return;
      }
      if (that.typeLogin == 1) {
        if (!info.phone || !/^1[3-9]\d{9}$/.test(info.phone)) {
          that.$toast('请输入正确的手机号');
          return;
        }
        if (!info.smscode || info.smscode.length < 4) {
          that.$toast('请输入短信验证码');
          return;
        }
      }
      if (that.typeLogin == 0) {
        if (!info.password || info.password.length < 6) {
          that.$toast('请输入正确的密码长度，最少6位');
          return;
        }
        if (!info.confirmPass || info.confirmPass != info.password) {
          that.$toast('两次密码不一致');
          return;
        }
      }

      // 图形验证码 —— 仅手机号注册(typeLogin=1)时需要；用户名注册(typeLogin=0)不校验
      // if (that.typeLogin == 1) {
      //   let code = that.registerInfo.code;
      //   if (!code) {
      //     that.$toast('请输入验证码');
      //     return;
      //   }
      //   if (code.toUpperCase() != that.imgLis[that.index]) {
      //     that.$toast('验证码错误');
      //     that.registerInfo.code = null;
      //     that.changIndex();
      //     return;
      //   }
      // }

      // that.$parent.showLoading();
      if (sessionStorage.getItem('pid') && !info.pid) {
        info.pid = sessionStorage.getItem('pid');
      }
      console.log(info)
      that.$apiFun.register(info).then(res => {
        that.$toast(res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          localStorage.setItem('token', res.data.api_token); // 持久化，关闭浏览器重开保持登录
          that.$store.commit('changToken');
          // 注册成功后立即刷新用户信息
          that.$apiFun.post('/api/user', {}).then(infoRes => {
            if (infoRes.code === 200) {
              let userInfo = infoRes.data;
              let str = userInfo.current_vip || '';
              let index = str.indexOf('P');
              userInfo.vip = index >= 0 ? str.substr(index + 1) : '';
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              that.$store.commit('changUserInfo');
            }
          });
          that.$emit("close");
        //   that.$parent.getUserInfo();
        //   that.$parent.openDaoTime();
        //   that.$parent.goNav('/');
        }
        // that.$parent.hideLoading();
      });
    },

  },
}
</script>
<style lang="scss" scoped>
@import '../../../static/css/common.css';
.login-new-box {
    width: 9rem;
    margin: 0 auto;
    background: #0a0a0a;
    min-height: 3rem;
    border-radius: .2rem;
    border: 1px solid #0a0a0a;
    margin-bottom: .4rem;
    
    .logo{
        background-image: url("/static/newImg/static/logo/comm_logo_bg1.png");
        background-color: #1E1F24;
        height: 1.2rem;
        text-align: center;
        padding-top: .2rem;
        border-radius: .2rem .2rem 0 0;
        // width: 100%;
        // position: absolute;
        // top: 0;
        // height: 1rem;
        // z-index: 2;
        object-fit: cover;
        object-position: top center;
    }
    .l{
        text-align: center;
        // padding-top: .3rem;
    }
    .tab{border-bottom: 1px solid #3B3C3D;font-size: .3rem;margin: 0 .3rem .3rem;}
    .login-content{padding: 0 .3rem .45rem;
        .check{border: 2px solid #1E1F24;border-radius: 5rem;height: 30px;margin-bottom: .3rem;}
        .gou{margin-left: .2rem;}
    }
    .btn{width: 100%;text-align: center;padding-top: .3rem;
        .other{color: #DFB372;margin-top: .3rem;padding: 0 .4rem;}
        .login-btn{ height: 1rem;line-height: 1rem; border:0; animation: pulse-green 1.5s infinite;}
    }
    .sms-btn{color: #dfb372;font-size: .28rem;white-space: nowrap;cursor: pointer;}
    .sms-btn-disabled{color: #999;cursor: not-allowed;}
}
@keyframes pulse-green {
    0% {transform: scale(1);box-shadow: 0 0 0 0 }
    70% {transform: scale(1.03);box-shadow: 0 0 10px rgba(223, 179, 114, .1) }
    100% {transform: scale(1);box-shadow: 0 0 10px 0 rgba(223, 179, 114, .8)}
    // 70% {transform: scale(1.03); box-shadow: 0 5px 10px rgba(0, 255, 102, 0) #00ff6600 }
    // 100% {transform: scale(1);box-shadow: 0 5px 30px 0 rgba(0, 255, 102,0)}
}

</style>

<style scoped>
.login-content /deep/ .van-tabs{font-size: 15px!important;}
.login-content /deep/ .van-cell{background: transparent!important;border: 1px solid #666!important;border-radius: .2rem!important;margin-bottom: .4rem!important;}
.login-content /deep/ .van-field__label{color: #FD5A70!important;width: .05rem!important;}
.login-content /deep/ .van-field__control{color: #fff!important;}
.login-content /deep/ .van-field__left-icon{color: #666!important;margin-right: .15rem;}
.field-icon{width: .45rem;height: .45rem;display: block;}
.check /deep/ .van-tabs__nav--card{border: none!important;}
.check /deep/ .van-tabs__nav--card{margin: 0!important;border-radius: 5rem;}
.check /deep/ .van-tabs__nav--card .van-tab.van-tab--active{border-radius: 5rem;}
.gou /deep/ .van-checkbox__label{color: #fff!important;}
</style>


// WEBPACK FOOTER //
// src/components/libs/loginNew.vue